module.exports = __webpack_public_path__ + "img/Mannfolk_Albertine-i--politilegens-venteverelse.2624383e.jpg";